import { useEffect, useState } from "react";
import {
  getSmartOfficeDomainInfo,
  getSmartOfficeEncryptionInfo,
} from "../../services/smartOfficeServices";
import useSimplePopup from "../../hooks/useSimplePopup";
import { AxiosResponse, HttpStatusCode } from "axios";
import { SmartOfficeEncryption } from "../../types/smartOffice";
import useShowActivity from "../../hooks/useShowActivity";
import { useNavigate } from "react-router-dom";
import { SMART_OFFICE_ERROR_CODE, SMART_OFFICE_ERROR_MESSAGE } from "../../consts/code";
import { useSmartOffice } from "../../hooks/useSmartOffice";

type Props = {};

export default function SmartOffice(props: Props) {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [simplePopupComponent, { open }] = useSimplePopup({});
  const [showActivityCall] = useShowActivity({ open });

  const [enc, setEnc] = useState<SmartOfficeEncryption | undefined>(undefined);
  const [smartOfficeDomain, setSmartOfficeDomain] = useState<
    string | undefined
  >(undefined);

  const {failedRedirect } = useSmartOffice();

  const errorCallback = (response: PromiseSettledResult<AxiosResponse<SmartOfficeEncryption | string, any>>, defaultErrorMessage?: string) => {
    if (response.status === "rejected" 
        && response.reason?.response?.data?.code === SMART_OFFICE_ERROR_CODE.INVALIDE_SMARTOFFICE_BUILDING) {
        open(SMART_OFFICE_ERROR_MESSAGE.INVALIDE_SMARTOFFICE_BUILDING, {onClick: () => failedRedirect(SMART_OFFICE_ERROR_CODE.INVALIDE_SMARTOFFICE_BUILDING) , enableDimmedClose:false});
        return ;
    } else if (
      response.status === "rejected" 
        && response.reason?.response?.data?.code === SMART_OFFICE_ERROR_CODE.NOT_VERIFIED_COMPANY) {
          open(SMART_OFFICE_ERROR_MESSAGE.NOT_VERIFIED_COMPANY, {onClick: () => failedRedirect(SMART_OFFICE_ERROR_CODE.NOT_VERIFIED_COMPANY) , enableDimmedClose:false});
        return ;
    }

    open("스마트 오피스 도메인 정보 조회에 실패 했습니다.", {onClick: failedRedirect , enableDimmedClose:false});
  }

  const loadSmartOfficeInfo = async () => {
    try {
      Promise.allSettled([
        getSmartOfficeEncryptionInfo(),
        getSmartOfficeDomainInfo(),
      ])
        .then((ress) => {
          const enc = ress[0];
          const domain = ress[1];

          if ( enc.status === "fulfilled" && enc.value.status === HttpStatusCode.Ok ) {
            setEnc(enc.value.data);
          } else {
            errorCallback(enc, "스마트 오피스 회원 정보 조회에 실패 했습니다.");
          }

          if ( domain.status === "fulfilled" && domain.value.status === HttpStatusCode.Ok ) {
            setSmartOfficeDomain(domain.value.data);
          } else {
            errorCallback(domain, "스마트 오피스 도메인 정보 조회에 실패 했습니다.");
          }
        })
      .finally(() => {
        setIsLoading(false);
      });
    } catch (e: any) {
      if (e?.response?.data?.error) {
        open(e?.response?.data?.error.replace(". ", ".\n"), {onClick: failedRedirect, enableDimmedClose:false});
      } else {
        open("스마트 오피스 연동 정보 조회에 실패 했습니다.", {onClick: failedRedirect, enableDimmedClose:false});
      }
    }
  };

  useEffect(() => {
    if (enc && smartOfficeDomain && !isLoading) {
      const fullUrl = `${smartOfficeDomain}?enc=${enc.enc}`;

      showActivityCall("스마트 오피스", fullUrl);

      setTimeout(() => {
        navigate("/view", { replace: true });
      }, 500);
    }
  }, [enc, smartOfficeDomain, isLoading]);

  useEffect(() => {
    // 1. 진입 시 스마트 오피스 정보를 요청한다.
    loadSmartOfficeInfo();
  }, []);

  return <>{simplePopupComponent}</>;
}
